export default __webpack_public_path__ + "static/media/datarhei.9f3aa55f.svg";